module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "mainProduct__starsList"
  }, _vm._l((5), function(item, index) {
    return _c('li', {
      staticClass: "mainProduct__starListItem"
    }, [_c('a', {
      key: "index",
      staticClass: "mainProduct__star",
      class: [item > _vm.pathProduct.stars ? 'mainProduct__star_gray' : 'mainProduct__star_bright'],
      attrs: {
        "href": "#"
      },
      on: {
        "mouseover": function($event) {
          return _vm.setStar(index)
        },
        "click": function($event) {
          return _vm.estimateProduct(index)
        }
      }
    })])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef2fbce8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/starsList.vue
// module id = 58
// module chunks = 0